<template>
  <div>
    <b-row class="mt-4">
      <b-col md="2" class="my-1" align="left">
        <b-form-group label-cols-sm="6" label="Show" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="3" class="my-1"></b-col>
      <b-col md="3" class="my-1" align="right">
      </b-col>
    </b-row>
    <br />
    <!-- <section v-if="table_error">
      <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
    </section> -->
    <b-table
      responsive
      show-empty
      hover
      ref="universalVoucherTable"
      :items="getDataUniversalVoucher"
      :fields="types"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      head-variant="light"
      class="bg-white"
    >
      <div slot="table-busy" class="text-center text-primary my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
      <template v-slot:cell(created_at)="{ item }">
        <p class="mb-0">{{item.created_at | DateTime}}</p>
      </template>
      <template v-slot:cell(status)="{ item }">
        <p class="mb-0 text-success font-weight-bold" v-if="item.status == 'on_progress'">On Progress</p>
        <p class="mb-0 font-weight-bold" v-else-if="item.status == 'success'">Success</p>
        <p class="mb-0 text-danger font-weight-bold" v-else-if="item.status == 'failed'">Failed</p>
      </template>
      <template v-slot:cell(action)="{item}">
        <b-row>
          <b-link v-b-tooltip.hover title="Edit" class="text-dark" @click="showModalFormUniversalVoucher('edit', item.id)">
            <img class="mr-2" src="@/assets/ic-view-detail.svg" alt />
          </b-link>
          <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="deleteUniversalVoucher(item.batch_no)">
            <img src="@/assets/rectangle.svg" class="mr-2" alt />
          </b-link>
        </b-row>
      </template>
    </b-table>
    <b-row class="mx-auto">
      <b-col md="4" align="left" class="mx-auto px-0">
        <div v-if="totalRows == 0 || totalRows == null">
          Showing 0 Records
        </div>
        <div v-else>
          Showing {{ fromPage[currentPage - 1] }} to
          {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
        </div>
      </b-col>
      <b-col md="4" class="mx-auto"></b-col>
      <b-col md="4" align="right" class="px-0">
        <b-pagination
          align="right"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-modal
      v-model="modalFormVoucherUniversalShow"
      size="l"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h2 class="font-weight-bold">Create Voucher</h2>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Voucher Name"
              label-for="input-1"
              style="font-size: 12px"
            >
              <input
                v-model="universal_voucher.voucher_name"
                v-validate="'required'"
                name="voucher_name"
                data-vv-as="Voucher Name"
                id="voucher_name"
                class="form-control"
                placeholder="Voucher Name"
              />
            <b-form-invalid-feedback id="input-voucher_name-feedback">{{
              veeErrors.first("voucher_name")
            }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Membership"
              label-for="input-1"
              style="font-size: 12px"
            >
              <b-form-checkbox-group
                v-model="universal_voucher.membership"
                data-vv-as="Membership"
                v-validate="'required'"
                name="membership"
                id="membership"
                stacked
              >
                <b-form-checkbox
                  v-for="member in universal_voucher_membership"
                  :key="member.value"
                  :value="member.value"
                >{{member.text}}</b-form-checkbox>
              </b-form-checkbox-group>
              <p style="width:100%;margin-top:.25rem;font-size: 80%;color: #e74a3b;">{{ veeErrors.first('membership') }}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-button
              variant="light"
              :disabled="loading_form_universal_voucher"
              @click="modalFormVoucherUniversalShow = !modalFormVoucherUniversalShow"
              class="text-primary"
              block
              size="lg"
              >Close</b-button
            >
          </b-col>
          <b-col>
            <b-button
              v-if="universal_voucher.id != ''"
              variant="primary"
              :disabled="loading_form_universal_voucher"
              @click="editUniversalVoucher()"
              block
              size="lg"
            >
              <b-spinner v-if="loading_form_universal_voucher" small label="Loading..."></b-spinner>
              <span v-else>Save & Run</span>
            </b-button>
            <b-button
            v-else
              variant="primary"
              :disabled="loading_form_universal_voucher"
              @click="createUniversalVoucher()"
              block
              size="lg"
            >
              <b-spinner v-if="loading_form_universal_voucher" small label="Loading..."></b-spinner>
              <span v-else>Save & Run</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_error: false,
      loading_universal_voucher: false,
      loading_form_universal_voucher: false,
      modalFormVoucherUniversalShow: false,
      universal_voucher: {
        id: "",
        voucher_name: "",
        membership: [],
      },
      universal_vouchers: [],
      types: [
        {
          key: "created_at",
          label: "Date | Time",
          sortable: false,
          class: "text-left w-10"
        },
        {
          key: "status",
          label: "Status",
          sortable: false,
          class: "text-left w-50"
        },
        { key: "action", label: "Action", class: "text-left w-10" }
      ],
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      // universal_voucher_name: "",
      // universal_voucher_membership_selected: [],
      universal_voucher_membership: [
        {text: "Gold", value: "gold"},
        {text: "Silver", value: "silver"},
        {text: "Gold2.0", value: "gold2.0"},
        {text: "Silver2.0", value: "silver2.0"},
        {text: "Non Member", value: "non_member"},
      ]
    }
  },
  methods: {
    getDataUniversalVoucher(ctx, callback) {
      this.loading_universal_voucher = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("app_name", "PaxelMarket3");
      formData.append("is_sort_asc", false);
      this.$store
        .dispatch("ReserveModule/getReserveLogWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.universal_vouchers = response.data.data.results || [];
          callback(response.data.data.results || []);
          this.loading_universal_voucher = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get universal voucher",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading_universal_voucher = false;
          callback([]);
        });
      return null;
    },
    showModalFormUniversalVoucher(action, id) {
      this.universal_voucher = {
        id: "",
        voucher_name: "",
        membership: [],
      };
      if (action == 'edit') {
        this.$store
        .dispatch("VoucherModule/getUniversalVoucher", id)
        .then(response => {
          this.universal_voucher = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
      }
      this.modalFormVoucherUniversalShow = !this.modalFormVoucherUniversalShow;
    },
    createUniversalVoucher() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading_form_universal_voucher = true;
          const formData = new FormData();
          formData.append("voucher_name", this.universal_voucher.voucher_name);
          formData.append("membership", this.universal_voucher.membership);
          this.$store
            .dispatch("VoucherModule/postUniversalVoucher", formData)
            .then((response) => {
              this.loading_form_universal_voucher = false;
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.modalFormVoucherUniversalShow = false;
              this.$refs.universalVoucherTable.refresh();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.data : "Failed store universal voucher",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.loading_form_universal_voucher = false;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    editUniversalVoucher() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading_form_universal_voucher = true;
          const formData = new FormData();
          formData.append("voucher_name", this.universal_voucher.voucher_name);
          formData.append("membership", this.universal_voucher.membership);
          this.$store
            .dispatch("VoucherModule/putUniversalVoucher", {
              id: this.universal_voucher.id,
              formData
            })
            .then((response) => {
              this.loading_form_universal_voucher = false;
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.modalFormVoucherUniversalShow = false;
              this.$refs.universalVoucherTable.refresh();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.data : "Failed store universal voucher",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.loading_form_universal_voucher = false;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    deleteUniversalVoucher(id) {
      this.$swal({
        text: `Are you sure want to delete reservation log?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6051a2",
        cancelButtonColor: "#f8f9fc",
        cancelButtonClass: "text-primary",
        confirmButtonText: "Delete",
        scrollbarPadding: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("ReserveModule/deleteReservationLog", id)
            .then((response) => {
              this.$swal("Deleted!", "Your data has been deleted.", "success");
              console.log(response);
              this.$refs.universalVoucherTable.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.message : "Failed to delete",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
            });
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  }
};
</script>